var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconmaterialPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.133,
    height: 16.63,
    viewBox: "0 0 26.133 16.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-people",
    "data-name": "Icon material-people",
    d: "M19.318,14.627a3.564,3.564,0,1,0-3.564-3.564A3.549,3.549,0,0,0,19.318,14.627Zm-9.5,0a3.564,3.564,0,1,0-3.564-3.564A3.549,3.549,0,0,0,9.815,14.627Zm0,2.376C7.047,17,1.5,18.393,1.5,21.16v2.97H18.13V21.16C18.13,18.393,12.583,17,9.815,17Zm9.5,0c-.344,0-.736.024-1.152.059a5.013,5.013,0,0,1,2.34,4.1v2.97h7.127V21.16C27.633,18.393,22.086,17,19.318,17Z",
    transform: "translate(-1.5 -7.5)",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmaterialPeople);
export default __webpack_public_path__ + "static/media/Icon material-people.3f15fa96dfabd0bf101486f06570ab2b.svg";
export { ForwardRef as ReactComponent };